<template>
  <div
    :id="data.id"
    class="container mb-20 mt-11 bg-gray-lighten3 md:mb-28 md:mt-14"
  >
    <div
      v-lazy-background="getAssetUrl(data.backgroundImage)"
      class="flex flex-col items-center justify-center rounded-lg bg-cover bg-top px-6 py-10 text-center text-white sm:min-h-[400px] sm:bg-center sm:py-14 md:min-h-[496px] 3xl:min-h-[672px]"
    >
      <CdnImg
        v-if="data.logoImage"
        :src="handleImageSrc(data.logoImage)"
        :alt="handleImageAlt(data.logoImage)"
        loading="lazy"
        class="mb-8"
        :width="132"
        :height="48"
      />

      <h2
        v-if="data.title"
        class="title mb-8 whitespace-pre-line text-3xl uppercase leading-none xl:text-6xl"
        v-html="data.title"
      />

      <div
        v-if="data.items && data.items.length"
        class="flex flex-col justify-center gap-4 sm:flex-row"
      >
        <div
          v-for="(item, i) in data.items"
          :key="i"
          class="flex h-[100px] w-[280px] flex-col items-center justify-center rounded-lg border-[1px] border-white px-4 sm:w-[300px] lg:w-[324px]"
        >
          <h3
            v-if="item.title"
            class="title mb-1 text-xl uppercase"
            v-html="item.title"
          />

          <p
            v-if="item.text"
            class="text-sm leading-[1.225rem]"
            v-html="item.text"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CdnImg } from '@webplatform/cdn-image';
import { useMediaAsset } from '~/composables';
import { handleImageSrc, handleImageAlt } from '~/helpers';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
</script>
